import React from "react";
import aiImage from "../../../assets/software.avif";
import SEOComponent from "../../SEOComponent";
import OptimizedImage from "../../OptimizedImage";
import strategyImage from "../../../assets/AI-Consulting.webp";
import strategyImage1 from "../../../assets/ai-strategy.png";
import dev1 from "../../../assets/dev1.png";
import dev2 from "../../../assets/dev2.png";
import dev3 from "../../../assets/dev3.png";
import dev4 from "../../../assets/dev4.png";
import dev5 from "../../../assets/dev5.png";
import del1 from "../../../assets/del1.png";
import del2 from "../../../assets/del2.png";
import del3 from "../../../assets/del3.png";
import del4 from "../../../assets/del4.png";
import del5 from "../../../assets/del5.png";
import del6 from "../../../assets/del6.png";

export default function AIStrategy() {
  return (
    <div className="bg-white">
      <SEOComponent 
        title="AI Strategy Development & Implementation Services | AlifShams"
        description="Expert AI strategy development and implementation services. Create comprehensive AI roadmaps, assess capabilities, and drive measurable ROI with strategic AI integration."
        keywords="AI strategy, AI implementation, AI roadmap, AI consulting, artificial intelligence strategy, AI transformation, AI business strategy, AI planning"
        url="https://digitalif.net/solutions/AIConsulting/AIstrategy"
        type="service"
      />
      {/* Hero Section */}
      <section className="relative h-[60vh] sm:h-[70vh] md:h-[800px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <OptimizedImage
            src={aiImage}
            alt="AI Consulting"
            className="w-full h-full object-cover sm:object-contain md:object-cover"
          />
          <div className="absolute inset-0 bg-black/60"></div>
        </div>
        <div className="relative z-10 text-center text-white px-4 sm:px-6">
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-bold mb-4 leading-tight">
            AI Strategy - Development & Implementation
          </h1>
          <p className="text-sm sm:text-lg md:text-xl lg:text-2xl max-w-3xl mx-auto leading-relaxed">
            Transform your business with cutting-edge AI solutions and strategic
            implementation
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Image - Left Side */}
            <div className="flex-1 w-full">
              <OptimizedImage
                src={strategyImage}
                alt="AI Strategy Development"
                className="w-full h-64 sm:h-80 md:h-96 object-cover rounded-lg shadow-lg"
              />
            </div>

            {/* Content - Right Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-[#482A7A] text-center lg:text-left">
                AI Strategy - Development & Implementation
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Develop comprehensive AI roadmaps aligned with business
                objectives. We assess your current capabilities, identify
                opportunities, and create strategic implementation plans that
                drive measurable ROI and competitive advantage.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed text-center lg:text-left">
                Our strategic approach ensures seamless integration of AI
                technologies into your existing infrastructure while maximizing
                business value and minimizing implementation risks.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Why AI Strategy Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 items-center">
            {/* Content - Left Side */}
            <div className="flex-1 w-full">
              <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-4 sm:mb-6 text-[#482A7A] text-center lg:text-left">
                Why AI Strategy?
              </h2>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed mb-4 sm:mb-6 text-center lg:text-left">
                Research shows that 85% of Artificial Intelligence projects fail to reach production.
              </p>
              <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed text-center lg:text-left">
                Our AI Scoping Programme de-risks your investment in AI and validates project feasibility before moving to development.
              </p>
            </div>

            {/* Image - Right Side */}
            <div className="flex-1 w-full flex justify-center">
              <div className="w-80 h-80 sm:w-96 sm:h-96 md:w-112 md:h-112 lg:w-128 lg:h-128 rounded-full bg-[#B31F7E] p-6 shadow-2xl flex items-center justify-center">
                <div className="w-full h-full rounded-full border-4 border-[#D66CAE] bg-[#D66CAE] p-3 shadow-lg">
                  <OptimizedImage
                    src={strategyImage1}
                    alt="Why AI Strategy"
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AI Strategy Development Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mb-6 text-[#482A7A] text-center">
            AI Strategy Development
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 text-center mb-12 max-w-4xl mx-auto">
            Throughout the scoping programme we look at all aspects of the AI solution to ensure the final product is seamlessly incorporated into your business operations.
          </p>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
            <div
              className="bg-transparent p-6 rounded-2xl border-t-4 border-t-blue-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-blue-500 group-hover:border-green-500 mx-auto mb-4 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={dev1}
                  alt="Data & Process"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-sm font-bold text-[#482A7A] transition-colors mb-2 text-center">Data & Process</h3>
              <p className="text-xs text-gray-600 text-center">Understand the business process and assess available data relevant to the business problem.</p>
            </div>
            <div
              className="bg-transparent p-6 rounded-2xl border-t-4 border-t-blue-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-blue-500 group-hover:border-green-500 mx-auto mb-4 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={dev2}
                  alt="Systems & Infrastructure"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-sm font-bold text-[#482A7A] transition-colors mb-2 text-center">Systems & Infrastructure</h3>
              <p className="text-xs text-gray-600 text-center">Understand existing processes and systems. Evaluate infrastructure requirements for new tech.</p>
            </div>
            <div
              className="bg-transparent p-6 rounded-2xl border-t-4 border-t-blue-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-blue-500 group-hover:border-green-500 mx-auto mb-4 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={dev3}
                  alt="Problem Embedding"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-sm font-bold text-[#482A7A] transition-colors mb-2 text-center">Problem Embedding</h3>
              <p className="text-xs text-gray-600 text-center">Translate commercial objectives into technical problem(s) that technology can address.</p>
            </div>
            <div
              className="bg-transparent p-6 rounded-2xl border-t-4 border-t-blue-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-blue-500 group-hover:border-green-500 mx-auto mb-4 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={dev4}
                  alt="AI/ML Solution Domains"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-sm font-bold text-[#482A7A] transition-colors mb-2 text-center">AI/ML Solution Domains</h3>
              <p className="text-xs text-gray-600 text-center">Identify relevant solution domain(s). Evaluate Open Source models vs Building bespoke</p>
            </div>
            <div
              className="bg-transparent p-6 rounded-2xl border-t-4 border-t-blue-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-blue-500 group-hover:border-green-500 mx-auto mb-4 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={dev5}
                  alt="Resourcing & Planning"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-sm font-bold text-[#482A7A] transition-colors mb-2 text-center">Resourcing & Planning</h3>
              <p className="text-xs text-gray-600 text-center">Define solution architecture and integration, Develop a roadmap and assess timeline and resources.</p>
            </div>
          </div>
        </div>
      </section>

      {/* AI Deliverables Section */}
      <section className="py-8 sm:py-12 md:py-16 px-4 sm:px-6 bg-gray-100">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-xl sm:text-2xl md:text-3xl font-bold mt-4 mb-6 text-[#482A7A]">
            AI Deliverables
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 mb-16 max-w-3xl mx-auto">
            AI expert delivers a step-by-step AI Strategy to achieve your business objectives.
          </p>
          
          <div className="flex flex-nowrap justify-center gap-6 overflow-x-auto pt-3">
            <div
              className="bg-transparent p-4 rounded-2xl border-t-4 border-t-purple-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group w-40 h-52 flex-shrink-0 flex flex-col items-center justify-center"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-purple-500 group-hover:border-green-500 mb-2 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={del1}
                  alt="AI Strategy Proposal"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xs font-bold text-[#482A7A] transition-colors text-center">AI Strategy Proposal</h3>
            </div>
            <div
              className="bg-transparent p-4 rounded-2xl border-t-4 border-t-purple-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group w-40 h-52 flex-shrink-0 flex flex-col items-center justify-center"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-purple-500 group-hover:border-green-500 mb-2 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={del2}
                  alt="Roadmap & Deliverables"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xs font-bold text-[#482A7A] transition-colors text-center">Roadmap & Deliverables</h3>
            </div>
            <div
              className="bg-transparent p-4 rounded-2xl border-t-4 border-t-purple-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group w-40 h-52 flex-shrink-0 flex flex-col items-center justify-center"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-purple-500 group-hover:border-green-500 mb-2 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={del3}
                  alt="Project Resources"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xs font-bold text-[#482A7A] transition-colors text-center">Project Resources</h3>
            </div>
            <div
              className="bg-transparent p-4 rounded-2xl border-t-4 border-t-purple-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group w-40 h-52 flex-shrink-0 flex flex-col items-center justify-center"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-purple-500 group-hover:border-green-500 mb-2 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={del4}
                  alt="Data and Cloud Infrastructure"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xs font-bold text-[#482A7A] transition-colors text-center">Data & Cloud Infrastructure</h3>
            </div>
            <div
              className="bg-transparent p-4 rounded-2xl border-t-4 border-t-purple-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group w-40 h-52 flex-shrink-0 flex flex-col items-center justify-center"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-purple-500 group-hover:border-green-500 mb-2 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={del5}
                  alt="Feasibility & Risk Assessment"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xs font-bold text-[#482A7A] transition-colors text-center">Risk Assessment</h3>
            </div>
            <div
              className="bg-transparent p-4 rounded-2xl border-t-4 border-t-purple-500 border-x-2 border-b-2 border-gray-300 hover:border-t-green-500 hover:shadow-2xl transition-all duration-300 cursor-pointer group w-40 h-52 flex-shrink-0 flex flex-col items-center justify-center"
              style={{ transform: "translateY(0px)" }}
              onMouseEnter={(e) => e.currentTarget.style.transform = "translateY(-10px)"}
              onMouseLeave={(e) => e.currentTarget.style.transform = "translateY(0px)"}
            >
              <div className="w-20 h-20 rounded-full border-2 border-purple-500 group-hover:border-green-500 mb-2 transition-colors duration-300 overflow-hidden">
                <OptimizedImage
                  src={del6}
                  alt="Integration & Scaling Requirements"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3 className="text-xs font-bold text-[#482A7A] transition-colors text-center">Integration & Scaling</h3>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}